import Page from '../page';
import FormValidator from '../../helpers/form-validator';

export default class ContactIndex extends Page {
    constructor(...args) {
        super(...args);

        bindAll(this, [
           '_process'
        ]),

        this._retrieveDOM();
        this._initTls();
    }

    _retrieveDOM() {
        this.dom.views = {};

        this.dom.views.body = document.body;
        this.dom.views.inputs = [].slice.call(this.dom.page.querySelectorAll('.js-input'));
        this.dom.views.buttonSend = this.dom.page.querySelector('.js-btn-send');
        this.dom.views.formContainer = this.dom.page.querySelector('.js-form-container');
        this.dom.views.formSuccess = this.dom.page.querySelector('.js-form-success');
        // this.dom.errorMessage = this.dom.page.querySelector('.js-error-message');
    }

    init() {
        super.init();

        this._action = 'bbi_contact';
        this._is_process = false;

    
        this._Validator = new FormValidator({
            'inputs' : this.dom.views.inputs,
            'parent' : false
        });
    }

    bind() {
        this.dom.views.buttonSend.addEventListener( 'click', this._process );
    }

    /**
     * Called when the user clicks on the submit button of the contact form => check the form data and continue the sending process
     * @param {Event} event - the button filter that was clicked
     * @private
     */
    _process( event ) {
        event.preventDefault();

        grecaptcha.ready(() => {
            grecaptcha.execute('6LcFqlEmAAAAAI8oG5E_hOWEw440r5sKc2gqfYBf', {action: 'submit'}).then((token) => {
                if ( this._is_process == false ) {

                    this._is_process = true;

                    let data = new FormData();
        
                    if( this._Validator.isValid() ) {
        
                        let formInputs = this._Validator.getData();
        
                        for(let item in formInputs) {
                            data.append( item, formInputs[ item ] );
                        }

                        data.append( 'token', token );

                        this._request( data );
        
                    } else {
                        this._is_process = false;
                    }
                }
            });
        });

       
    }

    /**
     * Make the request Ajax to send the message
     * @param {FormData} data - the form data
     * @private
     */
    _request( data ) {

        this.dom.views.body.classList.add( 'loading' );
        this.dom.views.buttonSend.classList.add( 'loading' );
        const xhr = new XMLHttpRequest();

        xhr.open( 'POST', '/wp-admin/admin-ajax.php?action=' + this._action, true );

        xhr.onreadystatechange = function () {

            if( xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200 ) {
                this._response( (JSON.parse( xhr.response ) ));
            }

            this._is_process = false;
            this.dom.views.buttonSend.classList.remove( 'loading' );
            this.dom.views.body.classList.remove( 'loading' );

        }.bind( this );

        xhr.send( data );
    }

    /**
     * Called when ajax request succeeded
     * @param {JSON} response - Request's response
     * @private
     */
    _response( response ) {
        console.log(response);
        if( response.success == true ) {

            if( ENV.template == 'desktop' )
                this.dom.views.formSuccess.style.height = this.dom.views.formContainer.getBoundingClientRect().height + 'px';

            // Hide form
            TweenMax.fromTo( this.dom.views.formContainer, 0.3, {y: 0, autoAlpha: 1}, { y: -50, autoAlpha: 0, onComplete: () => {

                    // Then, show success text
                    this.dom.views.formContainer.classList.add('success');
                    this.dom.views.formSuccess.classList.add('success');

                    if( ENV.template == 'mobile' ) {
                        let offset = this.dom.views.formContainer.getBoundingClientRect().top + window.scrollY - 60;
                        TweenMax.to( window, 0.3, { scrollTo: { y: offset } } )
                    }

                    TweenMax.fromTo( this.dom.views.formSuccess, 0.3, {y: 50, autoAlpha: 0}, { y: 0, autoAlpha: 1 } )

                } } )

        } else {
            this._is_process = false;
            /** Bad email **/
            // if( response.data.error == 'invalid_email' ) {}
        }
    }

    /**
     * init() {}
     * bind() {}
     * unbind() {}
     * resize(width, height) {}
     * _destroy() {}
     */
}



// WEBPACK FOOTER //
// ./src/js/pages/contact/contact-index.js